<template lang="pug">

  div

    v-dialog(v-model="show" max-width="800px" :persistent="loading === true")

      .dialogHeader

        .dialogHeaderTitle
          | Dividir plantão

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="closeDialog()")

      .dialogBody

        .dialogBodyContent

          .dialogSubtitle
            | PLANTÃO ORIGINAL:

          .mt-3(style="vertical-align: middle")
            i(aria-hidden="true" class="mdi mdi-calendar-clock" style="font-size: 18px; display: inline-block; vertical-align: middle;")
            b(style="display: inline-block; vertical-align: middle;") &nbsp;Data e horário:
            span(style="display: inline-block; vertical-align: middle;") &nbsp;{{ startDateTimeFormatted }}

          div(style="vertical-align: middle")
            i(aria-hidden="true" class="mdi mdi-timer-sand" style="font-size: 18px; display: inline-block; vertical-align: middle;")
            b(style="display: inline-block; vertical-align: middle;") &nbsp;Duração:
            span(style="display: inline-block; vertical-align: middle;") &nbsp;{{ durationFormatted }}

          div(style="vertical-align: middle")
            i(aria-hidden="true" class="mdi mdi-currency-usd" style="font-size: 18px; display: inline-block; vertical-align: middle;")
            b(style="display: inline-block; vertical-align: middle;") &nbsp;Valor final:
            span(style="display: inline-block; vertical-align: middle;") &nbsp;{{ dutyValueFormatted }}

          .dialogSubtitle.mt-7
            | NOVOS PLANTÕES

          .splitTable

            table.mt-3.managerUsersTable.splitUserSelect(border="0" cellspacing="0" cellpadding="0")
              thead
                tr.managerUserItem.managerUserItemHeader
                  th(width="250") Usuário
                  th Duração
                  th(style="min-width: 100px") Valor
                  th(style="min-width: 185px") Inicio e fim
                  th(style="min-width: 185px").last Escala

              tbody

                tr.managerUserItem

                  td(data-label="Usuário")

                    v-select(v-model="campoPlantonistaSelecionado1" :items="users" hide-details :disabled="loading").mt-0.pt-0
                      template(v-slot:selection="{ item, index }")
                        .splitShiftUserItem
                          img(:src="item.image").editDutyUserImage
                          span(v-html="item.text").editDutyUserNameSelect
                      template(v-slot:item="{ item }")
                        .splitShiftUserItem
                          img(:src="item.image").editDutyUserImage
                          span(v-html="item.text").editDutyUserNameSelect

                    template(v-if="campoPlantonistaSelecionado1.length > 1")
                      span(v-if="firstUserHourlyRate.rawValue >= 1.00").userHourlyRate {{ `Valor hora: ${firstUserHourlyRate.formattedValue}` }}
                      span(v-if="firstUserHourlyRate.rawValue > 0.01 && firstUserHourlyRate.rawValue < 1.00").userHourlyRate.userHourlyRate--invalid {{ `Valor hora (Não aplicável): ${firstUserHourlyRate.formattedValue}` }}
                      span(v-if="firstUserHourlyRate.rawValue === 0.00").userHourlyRate.userHourlyRate--invalid {{ 'Valor hora não definido' }}

                  td(data-label="Duração")

                    sos-select(label="" :default="selectedDuration1" @sosSelectChanged="onSelectDuration1" :items="durationOptions1" :fullscreen="true" fullscreenTitle="Duração")

                    //- .sosFieldGroupError(v-if="selectedDurationHour === '' || selectedDurationMinute === ''")
                      | Informe a duração.

                  td(data-label="Valor")
                    span {{ dividedDuties.firstDuty.valueFormatted }}

                  td(data-label="Inicio e fim")

                    .fixHeight
                      template(v-if="newShiftEnd1 === 'Escolha a duração'")
                        span.newSplitShiftItemStartDateTime Escolha a duração
                      template(v-else)
                        i(aria-hidden="true" class="mdi mdi-timer-sand" style="font-size: 15px; display: inline-block; vertical-align: middle;")
                        | &nbsp;
                        span.newSplitShiftItemStartDateTime {{ startDateTimeFormatted }}
                        br
                        i(aria-hidden="true" class="mdi mdi-timer-sand-complete" style="font-size: 15px; display: inline-block; vertical-align: middle;")
                        | &nbsp;
                        span.newSplitShiftItemStartDateTime {{ newShiftEnd1 }}

                  td(data-label="Escala")
                    sos-select(:fullscreen="true" fullscreenTitle="Escala" :fullscreenAutoWidth="true" :autoHeight="true" label="" :labelDescription="listeners.loadingGroupScales === 'no' && processedGroupScales.length === 0 ? '(Nota: O grupo não tem escalas)' : ''" :items="selectScales1" @sosSelectChanged="(scaleID) => onSelectScale(scaleID, 'dutyScaleID1')" :default="dutyScaleID1" :disabled="loading")

                tr.managerUserItem

                  td(data-label="Usuário")

                    v-select(v-model="campoPlantonistaSelecionado2" :items="users" hide-details :disabled="loading").mt-0.pt-0
                      template(v-slot:selection="{ item, index }")
                        .splitShiftUserItem
                          img(:src="item.image").editDutyUserImage
                          span(v-html="item.text")
                          //- span(v-html="item.text").editDutyUserNameSelect
                      template(v-slot:item="{ item }")
                        .splitShiftUserItem
                          img(:src="item.image").editDutyUserImage
                          span(v-html="item.text")
                          //- span(v-html="item.text").editDutyUserNameSelect

                    template(v-if="campoPlantonistaSelecionado2.length > 1")
                      span(v-if="secondUserHourlyRate.rawValue >= 1.00").userHourlyRate {{ `Valor hora: ${secondUserHourlyRate.formattedValue}` }}
                      span(v-if="secondUserHourlyRate.rawValue > 0.01 && secondUserHourlyRate.rawValue < 1.00").userHourlyRate.userHourlyRate--invalid {{ `Valor hora (Não aplicável): ${secondUserHourlyRate.formattedValue}` }}
                      span(v-if="secondUserHourlyRate.rawValue === 0.00").userHourlyRate.userHourlyRate--invalid {{ 'Valor hora não definido' }}

                  td(data-label="Duração")

                    //- input(v-model="selectedDurationFormatted2" :disabled="true" readonly).sosInput
                    span.newSplitShiftItemStartDateTime {{ selectedDurationFormatted2 }}

                    //- .sosFieldGroupError(v-if="selectedDurationHour === '' || selectedDurationMinute === ''")
                      | Informe a duração.

                  td(data-label="Valor")
                    span {{ dividedDuties.secondDuty.valueFormatted }}

                  td(data-label="Inicio e fim")

                    .fixHeight
                      template(v-if="newShiftEnd2 === 'Escolha a duração'")
                        span.newSplitShiftItemStartDateTime Escolha a duração
                      template(v-else)
                        i(aria-hidden="true" class="mdi mdi-timer-sand" style="font-size: 15px; display: inline-block; vertical-align: middle;")
                        | &nbsp;
                        span.newSplitShiftItemStartDateTime {{ newShiftEnd1 }}
                        br
                        i(aria-hidden="true" class="mdi mdi-timer-sand-complete" style="font-size: 15px; display: inline-block; vertical-align: middle;")
                        | &nbsp;
                        span.newSplitShiftItemStartDateTime {{ newShiftEnd2 }}

                  td(data-label="Escala")
                    sos-select(:fullscreen="true" fullscreenTitle="Escala" :fullscreenAutoWidth="true" :autoHeight="true" label="" :labelDescription="listeners.loadingGroupScales === 'no' && processedGroupScales.length === 0 ? '(Nota: O grupo não tem escalas)' : ''" :items="selectScales2" @sosSelectChanged="(scaleID) => onSelectScale(scaleID, 'dutyScaleID2')" :default="dutyScaleID2" :disabled="loading")

          .mt-7.text-right
            sos-button(@buttonClick="split" buttonLabel="Dividir plantão" buttonIcon="mdi-call-split" buttonIconSize="20" size="medium" color="success" :loading="loading" :disabled="loading")

    //- DIALOG PARA CONFIRMAÇÃO OU INFORMAÇÃO
    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

</template>

<script>

  import ConfirmDialog from '@/modals/ConfirmDialog'
  import SosButton from '@/components/SosButton'
  import SosSelect from '@/components/SosSelect'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'
  import { formatDuration, durationToMinutes, formatMoney } from '@/mixins/utils'

  import { apiGetUserId } from '@/services/firebase'
  import { apiSplitDuty } from '@/services/duties'

  import { mapState } from 'vuex'

  import moment from 'moment'
  import 'moment/locale/pt-br'

  moment.locale('pt-BR')

  //
  // COMPONENT
  //

  const defaultOptions = [
    { key: 'dm_nenhum', text: 'Nenhum', value: '0' },

    { key: 'dm_00_10', text: '10 minutos', value: '00:10' },
    { key: 'dm_00_20', text: '20 minutos', value: '00:20' },
    { key: 'dm_00_30', text: '30 minutos', value: '00:30' },
    { key: 'dm_00_40', text: '40 minutos', value: '00:40' },
    { key: 'dm_00_50', text: '50 minutos', value: '00:50' },

    { key: 'dh_01_00', text: '1 hora', value: '01:00' },
    { key: 'dm_01_10', text: '1 hora e 10 minutos', value: '01:10' },
    { key: 'dm_01_20', text: '1 hora e 20 minutos', value: '01:20' },
    { key: 'dm_01_30', text: '1 hora e 30 minutos', value: '01:30' },
    { key: 'dm_01_40', text: '1 hora e 40 minutos', value: '01:40' },
    { key: 'dm_01_50', text: '1 hora e 50 minutos', value: '01:50' },

    { key: 'dh_02_00', text: '2 horas', value: '02:00' },
    { key: 'dm_02_10', text: '2 horas e 10 minutos', value: '02:10' },
    { key: 'dm_02_20', text: '2 horas e 20 minutos', value: '02:20' },
    { key: 'dm_02_30', text: '2 horas e 30 minutos', value: '02:30' },
    { key: 'dm_02_40', text: '2 horas e 40 minutos', value: '02:40' },
    { key: 'dm_02_50', text: '2 horas e 50 minutos', value: '02:50' },

    { key: 'dh_03_00', text: '03 horas', value: '03:00' },
    { key: 'dm_03_10', text: '03 horas e 10 minutos', value: '03:10' },
    { key: 'dm_03_20', text: '03 horas e 20 minutos', value: '03:20' },
    { key: 'dm_03_30', text: '03 horas e 30 minutos', value: '03:30' },
    { key: 'dm_03_40', text: '03 horas e 40 minutos', value: '03:40' },
    { key: 'dm_03_50', text: '03 horas e 50 minutos', value: '03:50' },

    { key: 'dh_04_00', text: '04 horas', value: '04:00' },
    { key: 'dm_04_10', text: '04 horas e 10 minutos', value: '04:10' },
    { key: 'dm_04_20', text: '04 horas e 20 minutos', value: '04:20' },
    { key: 'dm_04_30', text: '04 horas e 30 minutos', value: '04:30' },
    { key: 'dm_04_40', text: '04 horas e 40 minutos', value: '04:40' },
    { key: 'dm_04_50', text: '04 horas e 50 minutos', value: '04:50' },

    { key: 'dh_05_00', text: '05 horas', value: '05:00' },
    { key: 'dm_05_10', text: '05 horas e 10 minutos', value: '05:10' },
    { key: 'dm_05_20', text: '05 horas e 20 minutos', value: '05:20' },
    { key: 'dm_05_30', text: '05 horas e 30 minutos', value: '05:30' },
    { key: 'dm_05_40', text: '05 horas e 40 minutos', value: '05:40' },
    { key: 'dm_05_50', text: '05 horas e 50 minutos', value: '05:50' },

    { key: 'dh_06_00', text: '06 horas', value: '06:00' },
    { key: 'dm_06_10', text: '06 horas e 10 minutos', value: '06:10' },
    { key: 'dm_06_20', text: '06 horas e 20 minutos', value: '06:20' },
    { key: 'dm_06_30', text: '06 horas e 30 minutos', value: '06:30' },
    { key: 'dm_06_40', text: '06 horas e 40 minutos', value: '06:40' },
    { key: 'dm_06_50', text: '06 horas e 50 minutos', value: '06:50' },

    { key: 'dh_07_00', text: '07 horas', value: '07:00' },
    { key: 'dm_07_10', text: '07 horas e 10 minutos', value: '07:10' },
    { key: 'dm_07_20', text: '07 horas e 20 minutos', value: '07:20' },
    { key: 'dm_07_30', text: '07 horas e 30 minutos', value: '07:30' },
    { key: 'dm_07_40', text: '07 horas e 40 minutos', value: '07:40' },
    { key: 'dm_07_50', text: '07 horas e 50 minutos', value: '07:50' },

    { key: 'dh_08_00', text: '08 horas', value: '08:00' },
    { key: 'dm_08_10', text: '08 horas e 10 minutos', value: '08:10' },
    { key: 'dm_08_20', text: '08 horas e 20 minutos', value: '08:20' },
    { key: 'dm_08_30', text: '08 horas e 30 minutos', value: '08:30' },
    { key: 'dm_08_40', text: '08 horas e 40 minutos', value: '08:40' },
    { key: 'dm_08_50', text: '08 horas e 50 minutos', value: '08:50' },

    { key: 'dh_09_00', text: '09 horas', value: '09:00' },
    { key: 'dm_09_10', text: '09 horas e 10 minutos', value: '09:10' },
    { key: 'dm_09_20', text: '09 horas e 20 minutos', value: '09:20' },
    { key: 'dm_09_30', text: '09 horas e 30 minutos', value: '09:30' },
    { key: 'dm_09_40', text: '09 horas e 40 minutos', value: '09:40' },
    { key: 'dm_09_50', text: '09 horas e 50 minutos', value: '09:50' },

    { key: 'dh_10_00', text: '10 horas', value: '10:00' },
    { key: 'dm_10_10', text: '10 horas e 10 minutos', value: '10:10' },
    { key: 'dm_10_20', text: '10 horas e 20 minutos', value: '10:20' },
    { key: 'dm_10_30', text: '10 horas e 30 minutos', value: '10:30' },
    { key: 'dm_10_40', text: '10 horas e 40 minutos', value: '10:40' },
    { key: 'dm_10_50', text: '10 horas e 50 minutos', value: '10:50' },

    { key: 'dh_11_00', text: '11 horas', value: '11:00' },
    { key: 'dm_11_10', text: '11 horas e 10 minutos', value: '11:10' },
    { key: 'dm_11_20', text: '11 horas e 20 minutos', value: '11:20' },
    { key: 'dm_11_30', text: '11 horas e 30 minutos', value: '11:30' },
    { key: 'dm_11_40', text: '11 horas e 40 minutos', value: '11:40' },
    { key: 'dm_11_50', text: '11 horas e 50 minutos', value: '11:50' },

    { key: 'dh_12_00', text: '12 horas', value: '12:00' },
    { key: 'dm_12_10', text: '12 horas e 10 minutos', value: '12:10' },
    { key: 'dm_12_20', text: '12 horas e 20 minutos', value: '12:20' },
    { key: 'dm_12_30', text: '12 horas e 30 minutos', value: '12:30' },
    { key: 'dm_12_40', text: '12 horas e 40 minutos', value: '12:40' },
    { key: 'dm_12_50', text: '12 horas e 50 minutos', value: '12:50' },

    { key: 'dh_13_00', text: '13 horas', value: '13:00' },
    { key: 'dm_13_10', text: '13 horas e 10 minutos', value: '13:10' },
    { key: 'dm_13_20', text: '13 horas e 20 minutos', value: '13:20' },
    { key: 'dm_13_30', text: '13 horas e 30 minutos', value: '13:30' },
    { key: 'dm_13_40', text: '13 horas e 40 minutos', value: '13:40' },
    { key: 'dm_13_50', text: '13 horas e 50 minutos', value: '13:50' },

    { key: 'dh_14_00', text: '14 horas', value: '14:00' },
    { key: 'dm_14_10', text: '14 horas e 10 minutos', value: '14:10' },
    { key: 'dm_14_20', text: '14 horas e 20 minutos', value: '14:20' },
    { key: 'dm_14_30', text: '14 horas e 30 minutos', value: '14:30' },
    { key: 'dm_14_40', text: '14 horas e 40 minutos', value: '14:40' },
    { key: 'dm_14_50', text: '14 horas e 50 minutos', value: '14:50' },

    { key: 'dh_15_00', text: '15 horas', value: '15:00' },
    { key: 'dm_15_10', text: '15 horas e 10 minutos', value: '15:10' },
    { key: 'dm_15_20', text: '15 horas e 20 minutos', value: '15:20' },
    { key: 'dm_15_30', text: '15 horas e 30 minutos', value: '15:30' },
    { key: 'dm_15_40', text: '15 horas e 40 minutos', value: '15:40' },
    { key: 'dm_15_50', text: '15 horas e 50 minutos', value: '15:50' },

    { key: 'dh_16_00', text: '16 horas', value: '16:00' },
    { key: 'dm_16_10', text: '16 horas e 10 minutos', value: '16:10' },
    { key: 'dm_16_20', text: '16 horas e 20 minutos', value: '16:20' },
    { key: 'dm_16_30', text: '16 horas e 30 minutos', value: '16:30' },
    { key: 'dm_16_40', text: '16 horas e 40 minutos', value: '16:40' },
    { key: 'dm_16_50', text: '16 horas e 50 minutos', value: '16:50' },

    { key: 'dh_17_00', text: '17 horas', value: '17:00' },
    { key: 'dm_17_10', text: '17 horas e 10 minutos', value: '17:10' },
    { key: 'dm_17_20', text: '17 horas e 20 minutos', value: '17:20' },
    { key: 'dm_17_30', text: '17 horas e 30 minutos', value: '17:30' },
    { key: 'dm_17_40', text: '17 horas e 40 minutos', value: '17:40' },
    { key: 'dm_17_50', text: '17 horas e 50 minutos', value: '17:50' },

    { key: 'dh_18_00', text: '18 horas', value: '18:00' },
    { key: 'dm_18_10', text: '18 horas e 10 minutos', value: '18:10' },
    { key: 'dm_18_20', text: '18 horas e 20 minutos', value: '18:20' },
    { key: 'dm_18_30', text: '18 horas e 30 minutos', value: '18:30' },
    { key: 'dm_18_40', text: '18 horas e 40 minutos', value: '18:40' },
    { key: 'dm_18_50', text: '18 horas e 50 minutos', value: '18:50' },

    { key: 'dh_19_00', text: '19 horas', value: '19:00' },
    { key: 'dm_19_10', text: '19 horas e 10 minutos', value: '19:10' },
    { key: 'dm_19_20', text: '19 horas e 20 minutos', value: '19:20' },
    { key: 'dm_19_30', text: '19 horas e 30 minutos', value: '19:30' },
    { key: 'dm_19_40', text: '19 horas e 40 minutos', value: '19:40' },
    { key: 'dm_19_50', text: '19 horas e 50 minutos', value: '19:50' },

    { key: 'dh_20_00', text: '20 horas', value: '20:00' },
    { key: 'dm_20_10', text: '20 horas e 10 minutos', value: '20:10' },
    { key: 'dm_20_20', text: '20 horas e 20 minutos', value: '20:20' },
    { key: 'dm_20_30', text: '20 horas e 30 minutos', value: '20:30' },
    { key: 'dm_20_40', text: '20 horas e 40 minutos', value: '20:40' },
    { key: 'dm_20_50', text: '20 horas e 50 minutos', value: '20:50' },

    { key: 'dh_21_00', text: '21 horas', value: '21:00' },
    { key: 'dm_21_10', text: '21 horas e 10 minutos', value: '21:10' },
    { key: 'dm_21_20', text: '21 horas e 20 minutos', value: '21:20' },
    { key: 'dm_21_30', text: '21 horas e 30 minutos', value: '21:30' },
    { key: 'dm_21_40', text: '21 horas e 40 minutos', value: '21:40' },
    { key: 'dm_21_50', text: '21 horas e 50 minutos', value: '21:50' },

    { key: 'dh_22_00', text: '22 horas', value: '22:00' },
    { key: 'dm_22_10', text: '22 horas e 10 minutos', value: '22:10' },
    { key: 'dm_22_20', text: '22 horas e 20 minutos', value: '22:20' },
    { key: 'dm_22_30', text: '22 horas e 30 minutos', value: '22:30' },
    { key: 'dm_22_40', text: '22 horas e 40 minutos', value: '22:40' },
    { key: 'dm_22_50', text: '22 horas e 50 minutos', value: '22:50' },

    { key: 'dh_23_00', text: '23 horas', value: '23:00' },
    { key: 'dm_23_10', text: '23 horas e 10 minutos', value: '23:10' },
    { key: 'dm_23_20', text: '23 horas e 20 minutos', value: '23:20' },
    { key: 'dm_23_30', text: '23 horas e 30 minutos', value: '23:30' },
    { key: 'dm_23_40', text: '23 horas e 40 minutos', value: '23:40' },
    { key: 'dm_23_50', text: '23 horas e 50 minutos', value: '23:50' },

    { key: 'dh_24_00', text: '24 horas', value: '24:00' },
    { key: 'dm_24_10', text: '24 horas e 10 minutos', value: '24:10' },
    { key: 'dm_24_20', text: '24 horas e 20 minutos', value: '24:20' },
    { key: 'dm_24_30', text: '24 horas e 30 minutos', value: '24:30' },
    { key: 'dm_24_40', text: '24 horas e 40 minutos', value: '24:40' },
    { key: 'dm_24_50', text: '24 horas e 50 minutos', value: '24:50' },
  ]

  export default {
    name: 'SplitShift',

    components: {
      ConfirmDialog,
      'sos-button': SosButton,
      'sos-select': SosSelect,
    },

    mixins: [
      confirmDialogMixin,
    ],

    data () {
      return {
        show: false,

        loading: false,

        groupID: '',
        scaleID: '',
        dutyScaleID1: '',
        dutyScaleID2: '',

        shiftID: '',
        waitingDutyID: '',
        dutyName: '',
        dutyLocal: '',
        dutyValue: '',

        dutyScaleUsers: null,

        users: [],
        startDateTime: '',
        startDateTimeFormatted: '',
        duration: '',
        durationFormatted: '',
        dutyValueFormatted: '',

        //
        //
        //

        campoPlantonistaSelecionado1: '0',
        campoPlantonistaSelecionado2: '0',

        durationOptions1: defaultOptions,
        selectedDuration1: '0',
      }
    },

    computed: {
      ...mapState(['listeners', 'groupScales']),
      // ...mapState(['userSession', 'groupUsers', 'groupShifts']),

      processedGroupScales () {
        return !!this.groupScales === true && Array.isArray(this.groupScales) && this.groupScales.length > 0 ? this.groupScales : []
      },

      selectScales1() {
        return this.selectScales('campoPlantonistaSelecionado1')
      },

      selectScales2() {
        return this.selectScales('campoPlantonistaSelecionado2')
      },

      //
      // Valor hora de cada plantonista selecionado (Se houver)
      //
      // JESUS: parseFloat necessário?
      //

      firstUserHourlyRate: function () {
        // console.log('dutyScaleUsers:', this.dutyScaleUsers)
        // // this.userHourlyRate('campoPlantonistaSelecionado2')

        // const rawValue = this.campoPlantonistaSelecionado1.length > 1 && !!this.dutyScaleUsers === true && !!this.dutyScaleUsers[this.campoPlantonistaSelecionado1] === true && !!this.dutyScaleUsers[this.campoPlantonistaSelecionado1].hourlyrate === true ? /* parseFloat( */ this.dutyScaleUsers[this.campoPlantonistaSelecionado1].hourlyrate /* ) */ : 0.00
        // return { rawValue, formattedValue: formatMoney(rawValue) }

        // const rawHallan = this.userHourlyRate('campoPlantonistaSelecionado1', 'dutyScaleID1')
        // console.log('>> rawHallan:', rawHallan)
        // console.log('>> rawAntigo:', { rawValue, formattedValue: formatMoney(rawValue) })
        return this.userHourlyRate('campoPlantonistaSelecionado1', 'dutyScaleID1')
      },

      // formattedValue: formatMoney(rawValue.toFixed(2))

      secondUserHourlyRate: function () {
        // const rawValue = this.campoPlantonistaSelecionado2.length > 1 && !!this.dutyScaleUsers === true && !!this.dutyScaleUsers[this.campoPlantonistaSelecionado2] === true && !!this.dutyScaleUsers[this.campoPlantonistaSelecionado2].hourlyrate === true ? /* parseFloat( */ this.dutyScaleUsers[this.campoPlantonistaSelecionado2].hourlyrate /* ) */ : 0.00
        // return { rawValue, formattedValue: formatMoney(rawValue) }
        return this.userHourlyRate('campoPlantonistaSelecionado2', 'dutyScaleID2')
      },

      //
      // Calcula o valor de cada plantão dividido
      //

      dividedDuties: function ()
      {
        if (!/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(String(this.selectedDuration1 || '')) || !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(String(this.selectedDuration2 || ''))) {
          return {
            firstDuty: { value: 0.00, valueFormatted: 'R$ 0,00' },
            secondDuty: { value: 0.00, valueFormatted: 'R$ 0,00' },
          }
        }

        // Valor total do plantão (dutyValue)
        const totalValue = this.dutyValue // exemplo: R$ 100,00

        // Duração do primeiro plantão (em minutos)
        const firstDutyMinutes = durationToMinutes(this.selectedDuration1) // exemplo: 5 horas = 300 minutos

        // Duração do segundo plantão (em minutos)
        const secondDutyMinutes = durationToMinutes(this.selectedDuration2) // exemplo: 4 horas e 30 minutos = 270 minutos

        // Duração total do plantão em minutos
        const totalMinutes = durationToMinutes(this.duration) // exemplo: 9 horas e 30 minutos = 570 minutos

        //
        // CALCULA OS VALORES PROPORCIONAIS USANDO REGRA DE TRÊS NO PRIMEIRO E SEGUNDO PLANTÕES
        //
        // 1ª CONDIÇÃO:
        //    - Valor hora do plantonista (selecionado) na escala
        //    - Duração do primeiro plantão
        //    Condição: Valor hora maior ou igual a R$ 1,00.
        //
        // 2ª CONDIÇÃO:
        //    - Valor do plantão original
        //    - Na duração do plantão original
        //    - Na duração do primeiro plantão
        //    Condição: Valor original maior ou igual a R$ 1,00.
        //
        // 3ª CONDIÇÃO:
        //    - Valor do plantão original.
        //    Condição: Valor original menor que R$ 1,00.
        //

        const firstDutyValue = this.firstUserHourlyRate.rawValue >= 1.00 ? (
          (firstDutyMinutes / 60) * this.firstUserHourlyRate.rawValue
        ) : (
          totalValue >= 1.00 ? (
            (firstDutyMinutes / totalMinutes) * totalValue
          ) : (
            totalValue
          )
        )

        const secondDutyValue = this.secondUserHourlyRate.rawValue >= 1.00 ? (
          (secondDutyMinutes / 60) * this.secondUserHourlyRate.rawValue
        ) : (
          totalValue >= 1.00 ? (
            (secondDutyMinutes / totalMinutes) * totalValue
          ) : (
            totalValue
          )
        )

        // Formata o valor com duas casas decimais
        return {
          firstDuty: { value: firstDutyValue.toFixed(2), valueFormatted: formatMoney(firstDutyValue.toFixed(2)) },
          secondDuty: { value: secondDutyValue.toFixed(2), valueFormatted: formatMoney(secondDutyValue.toFixed(2)) },
        }
      },

      //
      //
      //

      selectedDuration2: function ()
      {
        if (!!this.calculaDuracaoRestante === false) return 'Nenhum'

        // Converte a duração restante de minutos para HH:mm
        const horas = Math.floor(this.calculaDuracaoRestante / 60)
        const minutos = this.calculaDuracaoRestante % 60
        return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`
      },

      selectedDurationFormatted2: function ()
      {
        if (!!this.calculaDuracaoRestante === false) return 'Nenhum'

        // Converte a duração restante de minutos para HH:mm
        const horas = Math.floor(this.calculaDuracaoRestante / 60)
        const minutos = this.calculaDuracaoRestante % 60
        return formatDuration(`${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}`)
      },

      //
      // Lógica para calcular a duração restante com base na duração selecionada em DURAÇÃO 1
      //

      calculaDuracaoRestante: function ()
      {
        if (!/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(String(this.selectedDuration1 || '')) || !/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(String(this.duration || ''))) return 0

        const selectedDurationInMinutos1 = durationToMinutes(this.selectedDuration1)
        const defaultDurationInMinutes1 = durationToMinutes(this.duration)

        return defaultDurationInMinutes1 - selectedDurationInMinutos1
      },

      //
      //
      //

      newShiftEnd1: function ()
      {
        if (!/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(String(this.selectedDuration1 || ''))) return 'Escolha a duração'

        const duracaoEmMinutos1 = durationToMinutes(this.selectedDuration1)

        return moment(this.startDateTime).add(duracaoEmMinutos1, 'minutes').format('DD/MM/YYYY [às] HH:mm')
      },

      //
      //
      //

      newShiftEnd2: function ()
      {
        if (!/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(String(this.selectedDuration2 || ''))) return 'Escolha a duração'

        const duracaoEmMinutos2 = durationToMinutes(this.selectedDuration2)

        return moment(this.newShiftEnd1, 'DD/MM/YYYY [às] HH:mm').add(duracaoEmMinutos2, 'minutes').format('DD/MM/YYYY [às] HH:mm')
      },
    },

    watch: {
      show: {
        immediate: true,
        handler: function (show, oldShow)
        {
          if (oldShow === true && show === false) this.reset()
        },
      },

      /* campoPlantonistaSelecionado1: {
        immediate: true,
        handler: function (current, previous)
        {
          if (!!current === true) {
            // [24/01/25] console.log('::: campoPlantonistaSelecionado1:', this.dutyScaleUsers, this.firstUserHourlyRate)
          }
        },
      },

      campoPlantonistaSelecionado2: {
        immediate: true,
        handler: function (current, previous)
        {
          if (!!current === true) {
            // [24/01/25] console.log('::: campoPlantonistaSelecionado2:', this.dutyScaleUsers, this.secondUserHourlyRate)
          }
        },
      }, */
    },

    beforeDestroy () {
      this.clear()
    },

    methods: {
      //
      //
      //

      reset () {
        this.show = false

        this.groupID = ''
        this.scaleID = ''
        this.dutyScaleID1 = ''
        this.dutyScaleID2 = ''

        this.shiftID = ''
        this.waitingDutyID = ''
        this.dutyName = ''
        this.dutyLocal = ''
        this.dutyValue = ''

        this.dutyScaleUsers = null

        this.users = []
        this.startDateTime = ''
        this.startDateTimeFormatted = ''
        this.duration = ''
        this.durationFormatted = ''
        this.dutyValueFormatted = ''

        this.campoPlantonistaSelecionado1 = '0'
        this.campoPlantonistaSelecionado2 = '0'

        this.durationOptions1 = defaultOptions
        this.selectedDuration1 = '0'

        // cd.mixin.js
        this.cdParameters = { title: '', text: '', buttonPosition: 'right', width: 330 }
      },

      clear () {
        this.reset()

        delete this.show

        delete this.groupID
        delete this.scaleID
        delete this.dutyScaleID1
        delete this.dutyScaleID2

        delete this.shiftID
        delete this.waitingDutyID
        delete this.dutyName
        delete this.dutyLocal
        delete this.dutyValue

        delete this.dutyScaleUsers

        delete this.users
        delete this.startDateTime
        delete this.startDateTimeFormatted
        delete this.duration
        delete this.durationFormatted
        delete this.dutyValueFormatted

        delete this.campoPlantonistaSelecionado1
        delete this.campoPlantonistaSelecionado2

        delete this.durationOptions1
        delete this.selectedDuration1

        // cd.mixin.js
        delete this.cdParameters
      },

      //
      //
      //

      closeDialog (success = false)
      {
        if (this.loading) return false

        if (success === 'success') this.$emit('success')

        this.show = false
      },

      //
      //
      //

      open (args = { groupID: '', scaleID: '', shiftID: '', waitingDutyID: '', dutyName: '', dutyLocal: '', dutyValue: '', users: [], dutyScaleUsers: null, startDateTime: '', duration: '' })
      {
        // console.log('::: open:', args)

        this.groupID = args.groupID
        this.scaleID = args.scaleID
        this.dutyScaleID1 = args.scaleID
        this.dutyScaleID2 = args.scaleID

        this.shiftID = args.shiftID
        this.waitingDutyID = args.waitingDutyID
        this.dutyName = args.dutyName
        this.dutyLocal = args.dutyLocal
        this.dutyValue = args.dutyValue

        this.dutyScaleUsers = args.dutyScaleUsers || null

        this.users = args.users
        this.startDateTime = args.startDateTime
        this.startDateTimeFormatted = moment(args.startDateTime).format('DD/MM/YYYY [às] HH:mm')
        this.duration = args.duration
        this.durationFormatted = formatDuration(args.duration)
        this.dutyValueFormatted = formatMoney(args.dutyValue || 0)

        this.campoPlantonistaSelecionado1 = '0'
        this.campoPlantonistaSelecionado2 = '0'

        this.durationOptions1 = [{ key: 'dm_nenhum', text: 'Nenhum', value: '0' }, ...defaultOptions.filter(opcao => opcao.value !== '0' && durationToMinutes(opcao.value) >= durationToMinutes('00:30') && durationToMinutes(opcao.value) <= durationToMinutes(args.duration) - 30)]
        this.selectedDuration1 = '0'

        //
        // SHOW
        //

        this.show = true
      },

      //
      //
      //

      onSelectDuration1 (duration1) {
        this.selectedDuration1 = duration1
      },

      //
      //
      //

      split ()
      {
        if (!/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(String(this.selectedDuration1 || ''))) {
          this.showMessage('Aviso', 'Selecione a duração do primeiro plantão')
          return false
        }

        if (!/^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(String(this.selectedDuration2 || ''))) {
          this.showMessage('Aviso', 'Não foi possível calcular a duração do segundo plantão. Por favor, tente novamente ou fale com nosso suporte.')
          return false
        }

        if (this.campoPlantonistaSelecionado1.length <= 1) {
          this.showMessage('Aviso', 'Selecione o profissional do primeiro plantão')
          return false
        }

        if (this.campoPlantonistaSelecionado2.length <= 1) {
          this.showMessage('Aviso', 'Selecione o profissional do segundo plantão')
          return false
        }

        const text = 'O plantão original será <b style="color: orangered">apagado permanentemente</b> do sistema e dos relatórios.<br /><br /><b>Deseja continuar e criar novos plantões?</b>'
        this.showDialog('Atenção!', text, 'split-shift', '', false, 'center', 400)
      },

      //
      //
      //

      async cdAction (cdResponse)
      {
        if (cdResponse === false) return false

        //
        //
        // Apagar plantão
        //
        //

        if (cdResponse.cdType === 'split-shift')
        {
          if (this.loading) return false

          // Início do primeiro e segundo plantão
          const selectedDutyStartDate1 = moment.utc(this.startDateTimeFormatted, 'DD/MM/YYYY [às] HH:mm')
          const selectedDutyStartDate2 = moment.utc(this.newShiftEnd1, 'DD/MM/YYYY [às] HH:mm')

          // Duração do primeiro e segundo plantão
          const [hours1, minutes1] = this.selectedDuration1.split(':')
          const [hours2, minutes2] = this.selectedDuration2.split(':')

          // ?
          const shifts = [{
            dutyOwnerID: this.campoPlantonistaSelecionado1,
            dutyScaleID: this.dutyScaleID1,

            dutyMessageDate: selectedDutyStartDate1.format('DD/MM/YYYY'),
            dataInicioFmt: selectedDutyStartDate1.format('YYYY-M-D'),

            dutyStartDate: selectedDutyStartDate1.unix() * 1000, // JESUS: Está correto ? É igual ao data_inicio do plantão original ? Cenário: "Bug do mês anterior por causa do unix timestamp e fuso horário? TRABALHADO ENTRE ABRIL E MAIO DE 2024 - VIDE BITBUCKET",
            dutyStartTime: selectedDutyStartDate1.format('HH:mm'),
            dutyDuration: minutes1 === '00' ? parseInt(hours1) : `${hours1}:${minutes1}`,

            dutyValue: this.dividedDuties.firstDuty.value, // this.dutyValue, // JESUS: Preservar?
          }, {
            dutyOwnerID: this.campoPlantonistaSelecionado2,
            dutyScaleID: this.dutyScaleID2,

            dutyMessageDate: selectedDutyStartDate2.format('DD/MM/YYYY'),
            dataInicioFmt: selectedDutyStartDate2.format('YYYY-M-D'),

            dutyStartDate: selectedDutyStartDate2.unix() * 1000, // JESUS: Está correto ?,
            dutyStartTime: selectedDutyStartDate2.format('HH:mm'),
            dutyDuration: minutes2 === '00' ? parseInt(hours2) : `${hours2}:${minutes2}`,

            dutyValue: this.dividedDuties.secondDuty.value, // this.dutyValue, // JESUS: Preservar?
          }]

          this.loading = true

          const request = await apiSplitDuty({
            origin: 'WEB',
            viewerID: apiGetUserId(),
            dutyID: this.shiftID,
            shifts
          })

          // Debug
          // console.log('::: SPLIT SHIFT RESPONSE > request:', request)

          this.loading = false

          // Mostra a resposta do back-end
          if (request.code !== 'OK') return this.showMessage(request.title, request.code === 'INVALID' ? request.message.join('\r\n') : request.message)

          this.closeDialog('success')
        }
      },

      onSelectScale (scaleID, dutyScaleID) {
        const scale = this.groupScales.length > 0 ? this.groupScales.find(scaleItem => scaleItem.scaleID === scaleID) : false

        if (!!scale === false) return false

        this.setScale(scale, dutyScaleID)
      },

      setScale (s, dutyScaleID) {
        this[dutyScaleID] = s.scaleID

        this.scaleValue = s.scaleValue
        this.scaleValueFormatted = s.scaleValueFormatted

        console.log('Atual scaleID:', this.scaleID)
        console.log('dutyscaleID1:', this.dutyScaleID1)
        console.log('dutyscaleID2:', this.dutyScaleID2)
      },

      selectScales (campoPlantonistaSelecionado) // 'campoPlantonistaSelecionado1' | 'campoPlantonistaSelecionado2'
      {
        if (this.processedGroupScales.length === 0) return []

        const userID = this[campoPlantonistaSelecionado]

        // ESCALAS DE CADA USUÁRIO DO GRUPO
        const userScales = this.processedGroupScales.filter(gs => gs.scaleRelatedUsers.some(relatedUserID => relatedUserID === userID)).map(gs => gs.scaleID)

        return this.processedGroupScales.filter(s => {
          return (
            // Usuário relacionado a todas as escalas (Nota: Segundo a regra de negócio = Nenhuma escala relacionada)
            userScales.length === 0 ||
            (
              // Usuário encontrado + Relacionado a escala do plantão a ser dividido
              userScales.length > 0 &&
              userScales.some(scaleID => scaleID === s.scaleID)
            )
          )
        }).map(s => {
          // const userSelectedScaleHasHourlyRate = !!s.scaleUsers === true && !!s.scaleUsers[userID] === true && !!s.scaleUsers[userID].hourlyrate === true
          // const userSelectedScaleHourlyRate = userSelectedScaleHasHourlyRate ? s.scaleUsers[userID].hourlyrate : 0
          // const userSelectedScaleHourlyRateFormatted = formatMoney(userSelectedScaleHourlyRate)

          return {
            key: `scale_${s.scaleID}`,
            value: s.scaleID,
            text: `<span class="journeyOption">${s.scaleName}<br />` + (
              `<span class="" style="display: inline-block; font-size: 13px; color: rgba(0, 0, 0, 0.54); margin-top: 4px;"><i aria-hidden="true" class="mdi mdi-map-marker"></i> ${s.scaleLocation.name}</span>`
              // `<span class="journeyOptionObservation"><span class="journeyBold">Valor hora</span>: ${s.scaleValueFormatted} <i class="journeyGray">(Escala)</i> ou ${userSelectedScaleHourlyRateFormatted} <i class="journeyGray">(Usuário na escala)</i></span></span>`
            ),
          }
        })
      },

      userHourlyRate(campoPlantonistaSelecionado, dutyScaleID) {
        const userID = this[campoPlantonistaSelecionado]

        const dutyScale = this.processedGroupScales.find(scale => scale.scaleID === this[dutyScaleID])
        const dutyScaleUsers = !!dutyScale === true && !!dutyScale.scaleUsers === true && typeof dutyScale.scaleUsers === 'object' && Array.isArray(dutyScale.scaleUsers) === false ? dutyScale.scaleUsers : null

        const rawValue = userID.length > 1 && !!dutyScaleUsers === true && !!dutyScaleUsers[userID] === true && !!dutyScaleUsers[userID].hourlyrate === true ? /* parseFloat( */ dutyScaleUsers[userID].hourlyrate /* ) */ : 0.00
        return { rawValue, formattedValue: formatMoney(rawValue) }
      }
    },
  }

</script>

<style lang="scss">

  .modalTimesheetField--showHourlyRate
  {
    font-size: 0;

    .csLabel {
      display: inline-block;
      height: auto;

      line-height: 15px;
    }

    .sosCheckboxLabel {
      color: #495057;
      font-size: 15px !important;
      font-weight: 500;
      // line-height: 20px !important;
      padding-left: 7px !important;
    }
  }

  //
  //
  //

  .splitUserSelect {
    .v-select {
      .v-select__selections {
        justify-content: flex-start;
        font-size: 16px;
        line-height: 30px;
        text-transform: none;
      }
    }

    .v-text-field {
      .v-input__slot:before,
      .v-input__slot:after {
        display: none;
      }
    }

    .v-select__selections {
      > input {
        display: none;
      }
    }

    .v-text-field {
      .v-input__append-inner {
        margin: 0 !important;
        padding: 0 !important;
        align-self: center !important;
      }
    }
  }

  //
  //
  //

  @media (max-width: 768px) {
    .splitUserSelect {
      .v-select {
        .v-select__selections {
          justify-content: end;
        }
      }
    }
  }

  //
  //
  //

  @media (max-width: 600px) {
    .splitUserSelect {
      .v-select {
        .v-select__selections {
          justify-content: flex-start;
        }
      }
    }
  }

</style>

<style lang="scss" scoped>

  .userHourlyRate {
    display: inline-block;
    padding: 2px 4px;
    background-color: dodgerblue;

    color: yellow;
    font-size: 12px;
    font-weight: 800;
    line-height: 1;

    &--invalid {
      background-color: indianred;
    }
  }

  .fixHeight {
    line-height: 1;
  }

  .splitTable {
    overflow: auto;
  }

  .managerUsersTable {
    width: 100%;
  }

  .managerUserItem {
    width: 100%;
    font-size: 0;
    line-height: 0;

    th {
      font-size: 15px;
      line-height: 30px;
    }

    td {
      font-size: 14px;
      line-height: 30px;
    }

    th,
    td {
      position: relative;

      padding-left: 10px;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-right: 10px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);

      color: #444444;
      text-align: left;

      &.last {
        border-right: 0;
      }
    }

    &.managerUserItemHeader {
      th {
        padding-top: 0;
        padding-bottom: 4px;
        border-bottom: 3px solid rgba(0, 0, 0, 0.05);
      }
    }

    &.last {
      th, td {
        border-bottom: 0;
      }
    }
  }

  /* @media (max-width: 1280px) {
    .managerUsersTable {
      min-width: 1164px;
    }
  } */

  @media (max-width: 768px)
  {
    .managerUsersTable {
      min-width: 0;

      thead {
        border: none;
        clip: rect(0 0 0 0);
        height: 1px;
        margin: -1px;
        overflow: hidden;
        padding: 0;
        position: absolute;
        width: 1px;
      }

      .managerUserItem {
        display: block;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
        border-left: 1px solid rgba(0, 0, 0, 0.1);
        border-right: 1px solid rgba(0, 0, 0, 0.1);
        border-bottom: 3px solid #ddd;
        border-radius: 10px;
        margin: 10px 0;

        td {
          display: block;
          text-align: right !important;
          padding: 10px 20px !important;

          &::before {
            content: attr(data-label);
            float: left;
            font-weight: bold;
            text-transform: uppercase;
          }

          &:last-child {
            border-bottom: 0;
          }
        }

        &.last {
          th,
          td {
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
          }
        }
      }
    }
  }

  @media (max-width: 600px) {
    .managerUsersTable {
      .managerUserItem {
        td {
          text-align: left !important;

          &::before {
            float: none;
            display: block;
            width: 100%;
          }
        }
      }
    }
  }

  //
  //
  //

  .splitShiftUserItem {
    white-space: nowrap;
  }

  .newSplitShiftItemStartDateTime {
    display: inline-block;
    vertical-align: middle;

    color: #656565;
    font-size: 15px;
  }

  .editDutyUserImage,
  .editDutyUserNameSelect {
    display: inline-block;
    vertical-align: middle;
  }

  .editDutyUserImage {
    width: 30px;
    border-radius: 100%;
    margin-right: 10px;
  }

  .editDutyUserNameSelect {
    max-width: 150px; // ...
    overflow: hidden; // ...

    color: #656565;
    font-size: 16px;
    text-overflow: ellipsis; // ...
  }

  //
  //
  //

  .dialogSubtitle {
    // margin-bottom: 20px;
    font-weight: bold;
  }

  .err {
    color: indianred;
    font-size: 15px;
    font-weight: 400;
    line-height: 1;
  }

  .modalTimesheetField {
    position: relative;
    width: 100%;
  }

  .modalTimesheetGenerateButton {
    position: absolute;
    right: 6px;
    top: 5px;
  }

  .inline-block {
    display: inline-block;
    vertical-align: middle;
  }

  .usersCountArea {
    line-height: 0;
  }

  .usersCount {
    font-size: 15px;
    line-height: 1;
  }

  .footerLeft {
    width: 50%;

    text-align: left;
  }

  .footerRight {
    width: 50%;
    text-align: right;
  }

</style>
